import styled from 'styled-components'
import { Color } from 'root-constants'
import { SvgImage } from 'components/SvgImage'
import { InputWithValidationIcons } from 'components/InputWithValidationIcons'

export const StyledEmail = {
  TitleContainer: styled.header`
    margin-top: 24px;

    strong {
      color: ${Color.PRIMARY};
    }
  `,
  Input: styled(InputWithValidationIcons)`
    margin-bottom: 8px;
    background-color: ${Color.WHITE};
  `,
  Disclaimer: styled.p`
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  `,
  LockIcon: styled(SvgImage)`
    flex-shrink: 0;
    margin-right: 8px;
  `,
  ButtonContainer: styled.div`
    position: relative;
    margin-bottom: 30px;
  `,
}
